import BaseDto from './BaseDto';

export default class BaremeDto extends BaseDto {
  get schema() { // eslint-disable-line
    return Object.assign(super.schema, {
      code: undefined,
      annee: undefined,
      libelle: undefined,
      timeStamp: undefined,
      arrondi: undefined,
      domaine: undefined,
    });
  }

  buildCustom() {
    super.buildCustom();
    if (!this.annee) {
      this.annee = new Date().getFullYear();
    }
    return this;
  }

  static getFactory(inoJson = {}) {
    return new BaremeDto(inoJson);
  }
}
